import React, { useEffect, useLayoutEffect, useState } from "react"
import AsyncSelect from "react-select/async";
import redirectURL from "../redirectURL";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// import Info from '../../../assets/icons/info.png'
import { getDecoder } from "../common/utils";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Select from 'react-select';




const EditTicket = ({ closeAddSlider, showSweetAlert, editFormParams, editRowNode }) => {

    const [ticketNo, setTicketNo] = useState('')
    const [lrNo, setLrNo] = useState('')
    const [invoiceNo, setInvoiceNo] = useState('')
    const [categoryType, setCategoryType] = useState({ label: "", value: "" })
    const [seveirity, setSeveirity] = useState({ label: "", value: "" })
    const [foNo, setFONo] = useState('')
    const [details, setDetails] = useState('')
    const [typeOptions, setTypeOptions] = useState([])
    const [seveirityOptions, setSeveirityOptions] = useState([
        { label: "Critical", value: "Critical" },
        { label: "High", value: "High" },
        { label: "Medium", value: "Medium" },
        { label: "Low", value: "Low" },
        { label: "Normal", value: "Normal" },
    ])
    const [editParams, setEditParams] = useState(editFormParams)


    var [uploadFile, setUploadFile] = useState([]);
    const [error1, setError1] = useState('');
    const [contactNo, setContactNo] = useState('')


    const generateTicketNumber = () => {
        const characters = '0123456789';
        let result = 'SNDUT'
        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    

    useEffect(() => {
        setTicketNo(generateTicketNumber())
        setEditParams(editFormParams)

      
    }, [editFormParams])

    const filteredStatusOptions = [
        { value: 2, label: 'Assigned' },
        { value: 3, label: 'In Progress' },
        { value: 4, label: 'Resolved' },
        { value: 5, label: 'Need Info' },
        { value: 6, label: 'On Hold' },
        { value: 7, label: 'Reopened' },
        { value: 8, label: 'Closed' },
    ];

    const allowedNextStates = {
        1: [2, 3, 4, 5, 6, 7, 8], // Open
        2: [3, 4, 5, 6, 7, 8],    // Assigned
        3: [4, 5, 6, 7, 8],       // In Progress
        4: [7, 8],                // Resolved
        5: [2, 3, 4, 5, 6, 7, 8], // Need Info
        6: [2, 3, 4, 5, 6, 7, 8], // On Hold
        7: [2, 3, 4, 5, 6, 7, 8], // Reopened
        8: [],                    // Closed
    };
    
    const getFilteredOptions = (currentStatus) => {
        const allowed = allowedNextStates[currentStatus] || [];
        return statusOptions.filter(option => allowed.includes(option.value));
    };




    const statusOptions = [
        { value: 1, label: 'Open' },
        { value: 2, label: 'Assigned' },
        { value: 3, label: 'In Progress' },
        { value: 4, label: 'Resolved' },
        { value: 5, label: 'Need Info' },
        { value: 6, label: 'On Hold' },
        { value: 7, label: 'Reopened' },
        { value: 8, label: 'Closed' }
    ]
    let filteredOptions;
    if (editParams?.status !== undefined) {
        filteredOptions = getFilteredOptions(editParams.status)
    }
    const changeHandler = (e, val) => {
        console.log(e, val, "changehandlerfun");
        if (e.value == 4) {

        }


        setEditParams(prevState => ({
            ...prevState,
            [val]: e.value
        }))

    };
    const changeHandler1 = (e, val) => {
        setEditParams(prevState => ({
            ...prevState,
            [val]: e.target.value
        }))

    };
    var updateTicket = (event) => {
        event.preventDefault();
        let params = {
            updateData: editParams,
            rownode: editRowNode,
            assignee_email: getDecoder().email
        }
        // console.log(params, "params");
        redirectURL.post("/updateTicketStatus", params)
            .then((response) => {
                // console.log(response, "response");
                if (response.data.status === "Success") {
                    console.log("successs update");


                    setEditParams({})
                    closeAddSlider()
                    showSweetAlert(true, response.data.message, "success")
                    loadData(value);
                }
                else {
                    showSweetAlert(true, response.data.message, "danger")

                }
            })

    }


    return (
        <>
            <form className="" style={{ padding: "20px", maxHeight: "700px", overflowY: "auto" }} id="formFile" enctype="multipart/form-data" onSubmit={updateTicket}>

                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Status
                    </label>
                    <Select
                        className="border-radius-0"
                        isMulti={false}
                        name="status"
                        value={statusOptions.find(option => option.value === editParams?.status)}
                        id="selectedFilter"
                        style={{ borderRadius: "0px" }}
                        onChange={(e) => changeHandler(e, "status")}
                        options={filteredOptions}
                    />
                  
                </div>
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Severity
                    </label>
                    <Select
                        className="border-radius-0"
                        isMulti={false}
                        name="severity"
                        value={editParams?.severity ? { label: editParams.severity, value: editParams.severity } : ''}
                        id="selectedFilter"
                        style={{ borderRadius: "0px" }}
                        onChange={(e) => changeHandler(e, "severity")}
                        options={seveirityOptions}
                    />

                </div>
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        Email
                    </label>
                    <input
                        type="text"
                        name="email"
                        value={editParams?.email ? editParams.email : ""}
                        className="editticket-input"
                        onChange={(e) => changeHandler1(e, "email")}
                        required
                        autoComplete='off'
                    />
                </div>
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        Description
                    </label>
                    <textarea
                        type="text"
                        name="description"
                        value={editParams?.description || ""}
                        className="editticket-input"
                        onChange={(e) => changeHandler1(e, "description")}
                        autoComplete='on'
                        required
                        
                    />
                </div>




                <div className="form-group" style={{ textAlign: "center" }}>
                    <button type="submit" className="btn btn-success"
                        style={{
                            padding: "8px 14px",
                            border: "none",
                            borderRadius: "4px",
                        }}
                    >Submit
                    </button>
                </div>
            </form>
        </>
    )
}
export default EditTicket